module.exports = __webpack_public_path__ + "media/images/email/ic_gmail-fbcee9eb7d23ef60ab78b7f19e4317a2.png";